<!-- rota: /fatura/faturabasma  (name: fatura-basma) -->
<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <entegratorsecim ref="entegratorsecim" @callStop="EntegratorAyarlariKayitEdilmedi"  @callDevam="EntegratorAyarlariKayitEdildi" @callEntegratorVar="EntegratorVar"></entegratorsecim>
    <v-dialog max-width="450px" v-model="loadingvmodelProgress" persistent> 
      <v-card>
        <v-card-title>{{ $t('E-Invoice') }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <p> İşlem devam ediyor... ({{ currentChunk }} / {{ totalChunks }})</p>
          </v-layout>
          <v-layout row wrap="">
            <div class="flex md12">
              <v-progress-linear
  :value="progressPercent"
  height="20"
  color="blue"
 
>
  {{ progressPercent }}%
</v-progress-linear>
            </div>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" @click="durdurGonderim" v-if="loadingvmodelProgress">
  Durdur
</v-btn>
        </v-card-actions>
      </v-card>
      
  
    </v-dialog>
    
   
    <v-dialog v-model="faturadialoggoster" scrollable="" max-width="850px">
      <v-card>
        <v-card-title>{{ $t('E-Invoice') }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap="">
            <div class="flex md12">
              <span id="demo2"> </span>
            </div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
<v-dialog persistent v-model="warningNotedialog" width="500">
      <v-card>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="warning">
            <v-toolbar-title class="baslikfont">{{$t('Attention')}} !</v-toolbar-title>
          </v-toolbar>
        </v-flex>

        <v-card-text>
         {{ "Seçili Cari İçin Aşağıdaki Uyarı Notu Girilmiş..!" }}<br></br>
         {{ this.warningNote }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat data-test="cari-uyari-iptal" @click="warningCancel()">
            {{ $t("cancel_button") }}
          </v-btn>
          <v-btn color="primary" flat data-test="cari-uyari-devam" @click="warningOk()">
            {{$t('Continue')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="deneyselVadeDialog" width="560">
      <v-card>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="warning">
            <v-toolbar-title class="baslikfont">{{ $t('Attention') }} !</v-toolbar-title>
          </v-toolbar>
        </v-flex>
        <v-card-text>
          {{ $t('Experimental-Due-Date-Warning') }}
          <v-checkbox
            class="vade-secenegi"
            data-test="deneysel-onay"
            v-model="deneyselVadeOnay"
            :label="$t('I-Have-Read-And-Approve')"
            hide-details=""
          ></v-checkbox>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat data-test="deneysel-iptal" @click="deneyselVadeIptal()">
            {{ $t("cancel_button") }}
          </v-btn>
          <v-btn color="primary" flat data-test="deneysel-devam" :disabled="!deneyselVadeOnay" @click="deneyselVadeOnayla()">
            {{ $t('Continue') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Tevkifat secenegi onayi. Vade seceneginin uyarisiyla ayni kalip; sebep de
         benzer: secenek IKI YONLU calisiyor, esik asilmazsa biletlerde daha once
         hesaplanmis tevkifat SIFIRLANIYOR ve bu etiketten anlasilmiyor. -->
    <v-dialog persistent v-model="tevkifatUyariDialog" width="560">
      <v-card>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="warning">
            <v-toolbar-title class="baslikfont">{{ $t('Attention') }} !</v-toolbar-title>
          </v-toolbar>
        </v-flex>
        <v-card-text>
          {{ $t('Withholding-By-Invoice-Total-Warning') }}
          <v-checkbox
            class="tevkifat-secenegi"
            data-test="tevkifat-onay"
            v-model="tevkifatUyariOnay"
            :label="$t('I-Have-Read-And-Approve')"
            hide-details=""
          ></v-checkbox>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat data-test="tevkifat-uyari-iptal" @click="tevkifatUyariIptal()">
            {{ $t("cancel_button") }}
          </v-btn>
          <v-btn color="primary" flat data-test="tevkifat-uyari-devam" :disabled="!tevkifatUyariOnay" @click="tevkifatUyariOnayla()">
            {{ $t('Continue') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="faturadialog" width="500">
      <v-card>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">{{$t('Attention')}} !</v-toolbar-title>
          </v-toolbar>
        </v-flex>

        <v-card-text>
          {{ dialogmesaj }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat data-test="fatura-onay-iptal" @click="mesajiptal()">
            {{ $t("cancel_button") }}
          </v-btn>
          <kaydetbutonu :action="faturala" data-test="fatura-onay-faturala">
            {{$t('Invoice')}}
          </kaydetbutonu>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-app id="inspire" light>
      <v-card flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{ $t('Print-Invoice') }} </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                flat=""
                solo-inverted=""
                hide-details
                v-model="search3"
                 :label="this.$t('Search')"
                append-icon="search"
              >
              </v-text-field>
            </v-toolbar>
          </v-flex>

          <v-dialog
            v-model="dialogfiltre"
            scrollable=""
            persistent=""
            max-width="750px"
          >
            <v-card color="grey lighten-5">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-card class="white--text">
                  <v-card color="grey lighten-5" flat="">
                    <v-card-actions>
                      <v-layout row="" wrap="">
                        <v-flex xs12 sm6 md6>
                          <v-layout justify-space-between column>
                            <masrafmerkezicomp
                              v-model="faturaList.Filtreler.Masraf"
                            ></masrafmerkezicomp>
                            <referansmerkezicomp
                              v-model="faturaList.Filtreler.Referans"
                              :coper="false"
                            ></referansmerkezicomp>
                            <v-select
                              :items="hesapgurubu"
                              clearable=""
                              hide-details=""
                              v-model="faturaList.Filtreler.HesapGrubu"
                              :label="$t('Account-Group')"
                              item-text="Adi"
                              item-value="Kod"
                              max-height="400"
                            ></v-select>

                            <v-autocomplete
                              hide-details=""
                              clearable
                              :items="gdsitems"
                              label="GDS"
                              multiple
                              item-text="text"
                              v-model="faturaList.Filtreler.GDSler"
                              item-value="value"
                            >
                              <template
                                slot="selection"
                                slot-scope="{ item, index }"
                              >
                                <div v-if="index === 0">
                                  <span>{{ item.text }}</span>
                                </div>
                                <span
                                  v-if="index === 1"
                                  class="grey--text caption"
                                  >(+{{
                                    faturaList.Filtreler.GDSler.length - 1
                                  }}
                                   {{ $t('Other') }}   )</span
                                >
                              </template>
                            </v-autocomplete>

                            <v-flex xs12 sm6 md6>
                              <v-checkbox
                                hide-details=""
                                v-model="faturaList.Filtreler.SifirTutar"
                                :label="$t('Not-Invoice-Tickets-with-Zero-Amounts')"
                              ></v-checkbox>
                            </v-flex>
                         
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-layout justify-space-between column>
                            <bolumcomp
                              v-model="faturaList.Filtreler.BolumKodu"
                            ></bolumcomp>
                            <v-text-field
                              v-model="faturaList.Filtreler.SiparisNo"
                              :label="$t('Order-No')"
                              hide-details=""
                            >
                            </v-text-field>

                            <v-autocomplete
                              hide-details=""
                              clearable
                              :items="itemsairlinelist"
                              :label="$t('Select-Airline')"
                              multiple
                              item-text="Title"
                              v-model="faturaList.Filtreler.Havayollari"
                              item-value="HavaYoluKodu"
                            >
                              <template
                                slot="selection"
                                slot-scope="{ item, index }"
                              >
                                <div v-if="index === 0">
                                  <span>{{ item.Title }}</span>
                                </div>
                                <span
                                  v-if="index === 1"
                                  class="grey--text caption"
                                  >(+{{
                                    faturaList.Filtreler.Havayollari.length - 1
                                  }}
                                  {{ $t('Other') }})</span
                                >
                              </template>
                            </v-autocomplete>
                            <v-autocomplete
                              hide-details=""
                              clearable
                              :items="odemesekli"
                              :label="$t('Select-Payment-Method')"
                              multiple
                              item-text="text"
                              v-model="faturaList.Filtreler.Odemeler"
                              item-value="value"
                            >
                              <template
                                slot="selection"
                                slot-scope="{ item, index }"
                              >
                                <div v-if="index === 0">
                                  <span>{{ item.text }}</span>
                                </div>
                                <span
                                  v-if="index === 1"
                                  class="grey--text caption"
                                  >(+{{
                                    faturaList.Filtreler.Odemeler.length - 1
                                  }}
                                  {{ $t('Other') }})</span
                                >
                              </template>
                            </v-autocomplete>
                               <v-flex xs12 sm6 md6>

          <v-select :items="odemesekli2" tabindex="55" hide-details="" clearable item-text="text" item-value="value"
            v-model="faturaList.Filtreler.InternetSatis" :label="$t('E-archive-Internet-Sales')"></v-select>
        </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <br />
                          <div class="card__text info white--text">
                            <h3>&nbsp; {{ $t('Options-v2') }}</h3>
                          </div>
                        </v-flex>

                        <v-flex xs12 sm4 md4>
                          <v-layout justify-space-between column>
                            <v-radio-group
                              :label="$t('Record-Type')"
                              v-model="faturaList.Filtreler.RecordType"
                            >
                              <v-radio :label="$t('All')" value="4"></v-radio>
                              <v-radio :label="$t('Ticket')" value="0"></v-radio>
                              <v-radio :label="$t('Seat')" value="1"></v-radio>
                              <v-radio :label="$t('Meal')" value="2"></v-radio>
                              <v-radio :label="$t('Additional-Luggage')" value="3"></v-radio>
                            </v-radio-group>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm4 md4>
                          <v-layout justify-space-between column>
                            <v-radio-group
                              v-model="faturaList.Filtreler.TarihTipi"
                              :label="$t('Date-Type')"
                              column
                            >
                              <v-radio :label="$t('Sales-Date')" :value="'0'">
                              </v-radio>
                              <v-radio
                                :label="$t('Sales') + ' - ' +  $t('Flight-Date')"
                                :value="'1'"
                              ></v-radio>
                              <v-radio
                                :label=" $t('Sales') +'-'+$t('Date-of-Return')"
                                :value="'2'"
                              ></v-radio>
                              <v-radio
                                :label=" $t('Sales-Flight') + ' - ' + $t('Date-of-Return')"
                                :value="'3'"
                              ></v-radio>
                            </v-radio-group>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm4 md4>
                          <v-layout justify-space-between column>
                            <v-radio-group
                              v-model="faturaList.Filtreler.CariTip"
                              :label="$t('Customertype_label')"
                              column
                            >
                              <v-radio :label="$t('All-v2')" :value="'0'"> </v-radio>
                              <v-radio :label="$t('Individual')" :value="'1'"></v-radio>
                              <v-radio :label="$t('Corporate')" :value="'2'"></v-radio>
                            </v-radio-group>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm4 md4>
                          <v-layout justify-space-between column>
                            <v-radio-group
                              v-model="faturaList.Filtreler.UcusTip"
                              :label="$t('Cyprus-Batum-Flights')"
                              column
                            >
                              <v-radio
                                :label="$t('Except-ECN-BUS')"
                                :value="'1'"
                              ></v-radio>
                              <v-radio
                                :label="$t('Only-ECN-BUS')"
                                :value="'2'"
                              ></v-radio>
                            </v-radio-group>
                          </v-layout>
                        </v-flex>
 
                        <v-flex xs12 sm4 md4>
                          <v-layout justify-space-between column>
                            <v-radio-group
                              :label="$t('E-Invoice-Status')"
                              v-model="faturaList.Filtreler.EFaturaKayitli"
                              column
                            >
                              <v-radio
                                data-test="efatura-kayitsiz"
                                :label="$t('Not-Registered-with-E-invoice')"
                                :value="false"
                              >
                              </v-radio>
                              <v-radio
                                data-test="efatura-kayitli"
                                :label="$t('E-Invoice-Registered-Client')"
                                :value="true"
                              ></v-radio>
                            </v-radio-group>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm4 md4>
                          <v-layout justify-space-between column>
                            <v-radio-group
                              v-model="faturaList.Filtreler.HatBilgi"
                              :label="$t('Line-Type')"
                              column
                            >
                              <v-radio :label="$t('Domestic-Line')" :value="false"> </v-radio>
                              <v-radio :label="$t('International-Line')" :value="true"></v-radio>
                            </v-radio-group>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  flat
                  data-test="filtre-iptal"
                  @click.native="filtreiptal()"
                  >{{ $t("cancel_button") }}</v-btn
                >
                <v-btn color="blue darken-1" data-test="kayitlari-getir" flat @click.native="getList()"
                  > {{ $t('Find-Records') }} </v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogopsiyon"
            scrollable=""
            persistent=""
            max-width="400px"
          >
            <v-card color="grey lighten-5">
              <v-card-title> {{ $t('Select-Option') }} </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm6 md6>
                    <v-layout justify-space-between column>
                      <tarihcomp
                        :etiket="$t('Invoice-Date')"
                        v-bind:defaultvalue="'ok'"
                        v-bind:value="faturaList.FaturaTarih"
                        v-model="faturaList.FaturaTarih"
                      ></tarihcomp>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-layout justify-space-between column>
                      <v-select
                        data-test="gib-seri"
                        :items="gibSeri1"
                        hide-details=""
                        v-model="faturaList.GibSeri"
                        :label="$t('Turkish-Revenue-Administration-Serial-No')"
                        item-text="Seri"
                        item-value="Seri"
                        max-height="400"
                      ></v-select>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-layout justify-space-between column>
                      <v-text-field
                        mask="AAA"
                        :label="$t('Paper-Invoice-Serial')"
                        hide-details=""
                        v-model="faturaList.FaturaSeri"
                      ></v-text-field>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-layout justify-space-between column>
                      <v-text-field
                        hide-details=""
                        mask="###########################"
                        :label="$t('Paper-Inv-Head-No')"
                        v-model="faturaList.FaturaNo"
                      ></v-text-field>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-select
                      data-test="dizayn-sec"
                      :items="dizaynsec"
                      @change="xsltsec(faturaList.FaturaBilgi.FaturaID)"
                      v-model="faturaList.FaturaBilgi.FaturaID"
                      hide-details=""
                      item-text="FaturaAciklama"
                      item-value="FaturaId"
                      :label="$t('Select-Design')"
                    ></v-select>
                    <reportbrosablon
                      v-show="false"
                      ref="reportbrosablon"
                      v-model="faturaList.FaturaBilgi.FaturaPdfID"
                      dizayngrupadi="Fatura"
                      objectname="Controllers.ReportBro.Invoice.InvoicePrint"
                    ></reportbrosablon>
                    <v-textarea
                      hide-details=""
                      v-model="faturaList.FaturaBilgi.FaturaDipAciklama"
                      :label="$t('E-invoice-Footer-Disclosure')"
                    ></v-textarea>
                   <v-flex xs12 sm12 md12 v-if="isCurrentSame">
                        <v-switch  label="Ünvan Bilgilerini Değiştir" v-model="changeTitleInfo"></v-switch>
                    </v-flex> 
                   <v-flex xs12 sm12 md12 v-if="changeTitleInfo">
                    <v-text-field hide-details=""  :label="$t('Title_label') + '1'" v-model="faturaList.EFaturaBilgi.Unvani"></v-text-field>
                    <v-text-field hide-details=""  :label="$t('Title_label') + '2'" v-model="faturaList.EFaturaBilgi.Unvani2"></v-text-field>
                    <v-text-field hide-details=""  :label="$t('Address_label') + '1'" v-model="faturaList.EFaturaBilgi.Adres1"></v-text-field>
                    <v-text-field hide-details=""  :label="$t('Address_label') + '2'" v-model="faturaList.EFaturaBilgi.Adres2"></v-text-field>
                    <v-text-field hide-details=""  :label="$t('Province_label')" v-model="faturaList.EFaturaBilgi.IlceSehir"></v-text-field>
                    <v-text-field hide-details=""  :label="$t('Invoice-E-mail')" v-model="faturaList.EFaturaBilgi.Email"></v-text-field>
                    <v-text-field hide-details=""  :label="$t('Taxcenter_label')" v-model="faturaList.EFaturaBilgi.VergiDairesi">
                    </v-text-field>
                    <v-text-field hide-details=""  :label="$t('Taxnumber_label')" v-model="faturaList.EFaturaBilgi.VergiNo"></v-text-field>
                    <v-text-field hide-details=""  :label="$t('Identity-Number')" v-model="faturaList.EFaturaBilgi.TcKimlikNo">
                    </v-text-field>
                    <v-text-field hide-details=""  maxlength="50" v-model="faturaList.EFaturaBilgi.Adi" :label="$t('Name_label')"></v-text-field>
                    <v-text-field hide-details=""  maxlength="50" v-model="faturaList.EFaturaBilgi.Soyadi" :label="$t('Surname_label')"></v-text-field>
                    <v-text-field hide-details=""  maxlength="50" v-model="faturaList.EFaturaBilgi.TUnvani" :label="$t('Title_label')"></v-text-field>
                    <v-text-field hide-details=""  maxlength="50" v-model="faturaList.EFaturaBilgi.DigerAdi" :label="$t('Othername_label')"></v-text-field>
                    <v-text-field hide-details=""  maxlength="50" v-model="faturaList.EFaturaBilgi.OnAdiEki" :label="$t('Suffixname_label')"></v-text-field>
                  
                  </v-flex> 
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <br />
                    <div class="card__text info white--text">
                      <h3>&nbsp; {{ $t('Options-v2') }}</h3>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-space-between column>
                      <v-flex xs12 sm12 md12>
                        <v-checkbox
                          v-model="faturaList.Opsiyonlar.FaturaTekSatir"
                          :label="$t('Write-Invoice-in-Single-Line')"
                          hide-details=""
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-checkbox
                          hide-details=""
                          v-model="faturaList.Opsiyonlar.OdemeSekliGrup"
                          :label="$t('Group-Payment-Method')"
                        ></v-checkbox>
                      </v-flex>
                      <v-layout>
                        <v-checkbox
                          v-model="faturaList.Opsiyonlar.DovizliFatura"
                          :label="$t('Foreign-Currency-Invoice')"
                          hide-details=""
                        ></v-checkbox>
                        <v-flex xs12 sm3 md4>
                          <v-autocomplete
                            v-if="dovizlifaturami"
                            hide-details=""
                            @change="kurgetir(faturaList.DovizBilgi.DDovizTipi)"
                            :items="doviztipi"
                            v-model="faturaList.DovizBilgi.DDovizTipi"
                            clearable
                            item-text="Title"
                            item-value="DovizKod"
                            :label="$t('Currency-Type')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm3 md3>
                          <dovizinput
                            v-if="dovizlifaturami"
                            v-model="faturaList.DovizBilgi.DKur"
                            :etiket="$t('Exchange-Amount')"
                          >
                          </dovizinput>
                        </v-flex>
                      </v-layout>
                      <v-checkbox
                        :label="$t('Do-Not-Print-Passenger-Name')"
                        v-model="faturaList.Opsiyonlar.YolcuGosterme"
                        hide-details=""
                      ></v-checkbox>
                      <v-checkbox
                        :label="$t('Do-Not-Print-Payment-Term')"
                        v-model="faturaList.Opsiyonlar.OdemeVade"
                        hide-details=""
                      ></v-checkbox>
                      <v-checkbox
                        class="vade-secenegi"
                        data-test="vade-secenegi"
                        :label="$t('Calculate-Ticket-Due-Dates-From-Invoice-Date')"
                        v-model="faturaList.Opsiyonlar.BiletOdemeVadesiFaturaTarihindenHesapla"
                        hide-details=""
                      ></v-checkbox>
                      <div class="tevkifat-satiri">
                        <v-checkbox
                          class="tevkifat-secenegi"
                          data-test="tevkifat-secenegi"
                          :label="$t('Calculate-Withholding-By-Invoice-Total')"
                          v-model="faturaList.Opsiyonlar.TevkifatiFaturaTutarinaGoreHesapla"
                          hide-details=""
                        ></v-checkbox>
                        <v-icon
                          class="tevkifat-info"
                          data-test="tevkifat-info"
                          small
                          :color="tevkifatAciklamaAcik ? 'primary' : 'grey'"
                          :title="$t('Withholding-By-Invoice-Total-Hint')"
                          @click.stop="tevkifatAciklamaAcik = !tevkifatAciklamaAcik"
                        >info</v-icon>
                      </div>
                      <div
                        v-if="tevkifatEsigi !== null"
                        class="caption grey--text tevkifat-aciklama"
                        data-test="tevkifat-esigi"
                      >
                        {{ $t('Withholding-Minimum-Invoice-Amount') }}:
                        {{ tevkifatEsigi | moneyformat }} {{ getparabirimi() }}
                      </div>
                      <div
                        v-if="tevkifatAciklamaAcik"
                        class="caption grey--text tevkifat-aciklama"
                        data-test="tevkifat-aciklama"
                      >
                        {{ $t('Withholding-By-Invoice-Total-Hint') }}
                      </div>
                      <v-flex xs12 sm12 md12>
                        <v-checkbox
                          hide-details=""
                          v-model="faturaList.Opsiyonlar.FaturaDetayBas"
                          :label="$t('Print-Invoice-Details')"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-select
          :items="paketSayilar"
          label="Paket Sayısı"
          v-model="paketSayi"
        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-flex>
         
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  flat
                  data-test="opsiyon-iptal"
                  @click.native="opsiyoniptal()"
                  >{{ $t("cancel_button") }}</v-btn
                >
                <v-btn color="blue darken-1" data-test="faturala" :disabled="currentSearchControl" flat @click.native="faturalasor()"
                  >{{$t('Invoice')}}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-container fluid="">
            <v-card flat>
              <v-layout row wrap="">
                <v-flex xs12 sm6 md2>
                  <tarihcomp
                    data-test="baslangic-tarih"
                    :etiket="$t('Starting-Date')"
                    v-model="faturaList.Filtreler.BaslangicTarih"
                    v-bind:defaultvalue="'ok'"
                    v-bind:value="faturaList.Filtreler.BaslangicTarih"
                  ></tarihcomp>
                </v-flex>

                <v-flex xs12 sm6 md2>
                  <tarihcomp
                    data-test="bitis-tarih"
                    :etiket="$t('Finishing-Date')"
                    v-bind:defaultvalue="'ok'"
                    v-bind:value="faturaList.Filtreler.BitisTarih"
                    v-model="faturaList.Filtreler.BitisTarih"
                  >
                  </tarihcomp>
                </v-flex>

                <v-flex xs12 sm12 md3>
                  <cariaracomp
                    data-test="baslangic-cari"
                    v-bind:etiket="$t('Select-Starting-Current')"
                    v-bind:value="faturaList.Filtreler.BaslangicCariKod"
                    :loading="loading"
                    v-model="faturaList.Filtreler.BaslangicCariKod"
                  ></cariaracomp>
                </v-flex>

                <v-flex xs12 sm12 md3>
                  <cariaracomp
                    ref="bitisCariAyarla"
                    data-test="bitis-cari"
                    v-bind:etiket="$t('Select-Ending-Current')"
                    v-bind:value="faturaList.Filtreler.BitisCariKod"
                    :loading="loading2"
                    v-model="faturaList.Filtreler.BitisCariKod"
                    v-bind:statecariyedek="statecari2"
                    @sendCurrentData="getCurrentData($event)"
                  ></cariaracomp>
                </v-flex>

                <v-flex>
                  <v-layout align-center="" justify-start="" fill-height>
                    <div v-if="load1">
                      <v-btn color="info" data-test="ara" @click="filtrelecontrol()" fab small="" dark>
                        <v-icon>search</v-icon>
                      </v-btn>
                    </div>
                    <div v-if="!load1">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </div>
                  </v-layout>
                </v-flex>

                <v-flex v-if="kayitvarmi" xs12 sm12 md12>
                  <v-card>
                    <v-card-title>
                      <v-alert
                        :value="true"
                        color="error"
                        icon="warning"
                        outline
                      >
                        <span class="font-weight-bold body-1">
                          {{ kayitvarmesaj }}
                        </span>
                      </v-alert>

                      <v-spacer></v-spacer>
                      <span
                        v-if="selected.length > 0"
                        class="red--text title mr-3"
                        data-test="secim-ozeti"
                      >
                        {{ selected.length }} {{ $t('Records-are-selected') }}
                        - {{ secilentoplamtutar | moneyformat }} {{ getparabirimi() }}
                      </span>
                      <v-btn
                        :disabled="seciliBiletbtn"
                        outline
                        v-show="secilibutonshow"
                        color="info"
                        data-test="devam-et"
                        @click="opsiyonlarial()"
                        dark
                      >
                      {{ $t('Continue') }}
                         <v-icon>chevron_right</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-data-table
                      data-test="bilet-tablosu"
                      v-if="carilerayni"
                      v-model="selected"
                      :headers="headers"
                      :items="itemsTicket"
                      select-all
                      item-key="BiletKod"
                      :custom-sort="customSort"
                      :search="search3"
                    >
                      <template slot="headers" slot-scope="props">
                        <tr>
                          <th>
                            <v-checkbox
                              :input-value="props.all"
                              :indeterminate="props.indeterminate"
                              primary
                              hide-details
                              data-test="tumunu-sec"
                              @click.native="toggleAll"
                            ></v-checkbox>
                          </th>
                          <th
                            v-for="header in props.headers"
                            :key="header.text"
                          >
                            {{ header.text }}
                          </th>
                        </tr>
                      </template>
                      <template slot="items" slot-scope="props">
                        <tr
                          :active="props.selected"
                          @click="props.selected = !props.selected"
                        >
                          <td>
                            <v-checkbox
                              :input-value="props.selected"
                              primary
                              hide-details
                            ></v-checkbox>
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.YolcuAdi }}
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.HavaYoluKodu }}
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.FormNo }}
                          </td>
                          <td class="text-xs-center">
                            <a
                              class="bilet-baglantisi"
                              data-test="bilet-no-baglantisi"
                              target="_blank"
                              rel="noopener"
                              :href="biletSayfasiAdresi(props.item)"
                              :title="$t('Open-Ticket-In-New-Tab')"
                              @click.stop
                            >{{ props.item.BiletNo }}</a>
                          </td>
                           <td class="text-xs-center">
                            {{ props.item.Parkurlar }}
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.RezervasyonAlan }}
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.RezervasyonVeren }}
                          </td>
                          <td class="text-xs-right">
                            {{ props.item.KdvTutar | moneyformat }}
                          </td>
                          <td class="text-xs-right">
                            {{ props.item.NetTutar | moneyformat }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-flex>

                <v-flex v-if="faturaSonView" xs12 sm12 md12>
                  <v-card>
                    <v-data-table
                      data-test="sonuc-tablosu"
                      :headers="headers2"
                      :rows-per-page-items="[20, 50,250,500,1000]"
                      :items="faturaItems"
                      :search="search3"
                    >
                      <template slot="items" slot-scope="props">
                        <tr item>
                          <td
                            v-if="props.item.FaturaStatus == true"
                            class="text-xs-left"
                          >
                            <h3 style="color:green;">{{ $t('Successful') }} </h3>
                          </td>
                          <td
                            v-if="props.item.FaturaStatus == false"
                            class="text-xs-left"
                          >
                            <h3 style="color:red;"> {{ $t('Unsuccessful') }}  </h3>
                          </td>
                          <td class="text-xs-left">
                            {{ props.item.FaturaResponse }}
                          </td>
                          <td class="text-xs-left">
                            {{ props.item.FaturaSeri }}
                          </td>
                          <td class="text-xs-left">
                            {{ props.item.FaturaNo }}
                          </td>
                          <td class="text-xs-left">
                            {{ props.item.FaturaGuid }}
                          </td>
                          <td class="text-xs-left">
                            {{ props.item.BiletInfo.FormNo }}
                          </td>
                          <td class="text-xs-left">
                            {{ props.item.BiletInfo.BiletNo }}
                          </td>

                          <v-btn
                            v-if="props.item.FaturaStatus == true"
                            icon
                            class="mx-0"
                          >
                            <v-icon
                              color="red"
                              @click="faturayazdir(props.item)"
                              >print</v-icon
                            >
                          </v-btn>
                          <v-btn
                            v-if="props.item.FaturaStatus == true"
                            icon
                            class="mx-0"
                          >
                            <v-icon
                              color="info"
                              @click="efaturagoster(props.item)"
                              >search</v-icon
                            >
                          </v-btn>
                        </tr>
                      </template>
                      <v-alert
                        slot="no-results"
                        :value="true"
                        color="error"
                        icon="warning"
                      >
                         {{ $t('No-records-searched-for', { value: search3}) }}
                      </v-alert>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card>
          </v-container>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import auth from "../../../api/auth";
import tarihcomp from "../customcomp/tarihim";
import bolumcomp from "@/components/app/bilet/partpage/bolumcomp.vue";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";
import dovizinput from "@/components/app/customcomp/dovizinput.vue";
import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";
import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import tool from "@/components/app/coper/tools";
import kaydetbutonu from "@/components/app/customcomp/kaydetbutonu.vue";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import entegratorsecim from "@/components/app/customcomp/entegratorsecim.vue";
export default {
  data() {
    return {
      warningNote:'',
      warningNotedialog:false,
      deneyselVadeDialog: false,
      tevkifatUyariDialog: false,
      tevkifatUyariOnay: false,
      // Aciklama varsayilan olarak KAPALI; info butonuyla aciliyor.
      tevkifatAciklamaAcik: false,
      // Tevkifat esigi (SirketParam.BiletTevkifatFaturaTutari). null iken satir
      // hic gosterilmiyor -- "0,00" yazmak yaniltici olurdu.
      tevkifatEsigi: null,
      deneyselVadeOnay: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
       odemesekli2: [
        {
            text: this.$t('All'),
            value: -1
          },
       {
            text: this.$t('Normal-Sales'),
            value: 0
          },
          {
            text: this.$t('Internet-Sales'),
            value: 1
          }
        ],
      totalChunks: 0,
    currentChunk: 0,
    progressPercent: 0,
    stopRequested: false,
      paketSayi:10,
      paketSayilar: [10, 25, 50, 100,250,500,600,700,800,900,1000],
      changeTitleInfo:false,
      isCurrentSame:false,
      currentSearchControl:false,
      loadingvmodel: false,
      loadingvmodelProgress:false,
      secilibutonshow: true,
      dovizlifaturami: false,
      doviztipi: [],
      gdsitems: [],
      itemsairlinelist: [],
      kayitvarmesaj: null,
      kayitvarmi: false,
      dialogopsiyon: false,
      text1: "",
      carilerayni: false,
      selected: [],
      seciliBiletbtn: true,
      gibSeri1: [],
      itemsTicket: [],
      faturaItems: [],
      faturaSonView: false,
      hesapgurubu: [],
      dialogmesaj: this.$t('you-sure-that-want-invoice-your-tickets-your-selections'),
      faturadialog: false,
      faturaList: {
        SirketKodu: null,
        FaturaTarih: null,
        FaturaSeri: null,
        FaturaNo: null,
        GibSeri: null,
        Filtreler: {
          BaslangicCariKod: null,
          BitisCariKod: null,
          BaslangicTarih: null,
          BitisTarih: null,
          HatBilgi: false,
          EFaturaKayitli: false,
          Masraf: null,
          SiparisNo: null,
          HavayoluKodu: null,
          HesapGrubu: null,
          TarihTipi: "0", // 0 : Satış Tarihi, 1 : Satış/Uçuş Tarihi, 2 : Satış/Donuş Tarihi , 3 : Satış/Gidiş - Donuş Tarihi
          Referans: null,
          UnvanDegistir:false,
          BolumKodu: null,
          Havayollari: [],
          Odemeler: [], // K : Kredili, P : Peşin , R: R- Kredi Katlı, F : F-KrediKartlı, C: C-KrediKartlı
          GDSler: [], // K : Kredili, P : Peşin , R: R- Kredi Katlı, F : F-KrediKartlı, C: C-KrediKartlı
          UcusTip: "0", // 0: Hepsi, 1 : Kıbrıs vb Hariç, 2 : Sadece Kıbrıs vb.
          SifirTutar: true,
          CariTip: "0", // 0 : Hepsi, 1 : Bireysel, 2 : Kurumsal
          RecordType: "4",
          InternetSatis:-1,
        },
        DovizBilgi: {
          EDovizTipi: null,
          EKur: 0,
          DDovizTipi: null,
          DKur: 0,
        },
        Opsiyonlar: {
          YolcuGosterme: false,
          OdemeVade: false,
          UnvanAdres: false,
          DovizliFatura: false,
          FaturaDetayBas: false,
          SifirTutarBilet: false,
          FaturaTekSatir: false,
          OdemeSekliGrup: false,
          BiletOdemeVadesiFaturaTarihindenHesapla: false,
          TevkifatiFaturaTutarinaGoreHesapla: false,
        },
        FaturaBilgi: {
          FaturaTip: null,
          FaturaID: null,
          FaturaPdfID: null,
          FaturaXSLTID: null,
          FaturaDipAciklama: null,
        },
        EFaturaBilgi:{
          Unvani:null,
          Unvani2:null,
          Adres1:null,
          Adres2:null,
          IlceSehir:null,
          Email:null,
          VergiDairesi:null,
          VergiNo:null,
          TcKimlikNo:null,
          Adi:null,
          Soyadi:null,
          TUnvani:null,
          DigerAdi:null,
          OnAdiEki:null
        }
      },

      odemesekli: [
        {
          text: "K-Kredili",
          value: "K",
        },
        {
          text: "P-Peşin",
          value: "P",
        },
        {
          text: this.$t('R-Card'),
          value: "R",
        },
        {
          text: this.$t('C-Card'),
          value: "C",
        },
        {
          text: this.$t('F-Card'),
          value: "F",
        },
      ],

      headers: [
        {
          text: this.$t('Name-of-Passenger'),
          value: "YolcuAdi",
          align: "center",
        },
        {
          text: this.$t('Airline-Code'),
          value: "HavaYoluKodu",
          align: "center",
        },
        {
          text: this.$t('Form-No'),
          value: "FormNo",
        },
        {
          text: this.$t('Ticket-No'),
          value: "BiletNo",
        },
        {
          text: "Parkurlar",
          value: "Parkurlar",
        },
        {
          text: "Rez. Alan",
          value: "RezervasyonAlan",
        },
        {
          text: "Rez. Veren",
          value: "RezervasyonVeren",
        },
        {
          text: this.$t('VAT-Amount'),
          value: "KdvTutar",
        },
        {
          text: this.$t('Net-Amount'),
          value: "NetTutar",
        },
      ],

      headers2: [
        {
          text: this.$t('Invoice-Status'),
          value: "FaturaStatus",
        },
        {
          text: this.$t('Invoice-Explanation'),
          value: "FaturaResponse",
        },
        {
          text: this.$t('Serial'),
          value: "FaturaSeri",
        },
        {
          text: this.$t('No'),
          value: "FaturaNo",
        },
        {
          text: "GUID",
          value: "FaturaGuid",
        },
        {
          text: this.$t('Form-No'),
          value: "BiletInfo.FormNo",
        },
        {
          text: this.$t('Ticket-No'),
          value: "BiletNo",
        },
      ],

      faturadialoggoster: false,
      dizaynsec: [],

      loading: false,
      loading2: false,
      yedekClass: null,
      // gonder2'nin hata dali bunu true yapar; faturalav3 sonuc mesajini buna gore yazar.
      gonderimHatasi: false,
      load1: true,
      search3: "",
      statecari2: [],
      dialogfiltre: false,

      snackbar: false,
      anaCancelValue: {},
      cancelValue: {},
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  components: {
    tarihcomp,
    bolumcomp,
    referansmerkezicomp,
    dovizinput,
    reportbrosablon,
    masrafmerkezicomp,
    yetkidialog,
    loadingcomp,
    cariaracomp,
    snackbarcomp,
    entegratorsecim,
    kaydetbutonu
  },

  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    if (this.sayfayetki.Status != true) {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          } 
        });
    }
  },
  watch: {
    // Deneysel secenek: her acilisinda uyari + onay istenir. Onaylanmazsa secenek geri alinir.
    "faturaList.Opsiyonlar.BiletOdemeVadesiFaturaTarihindenHesapla": function(val) {
      if (val === true) {
        this.deneyselVadeOnay = false;
        this.deneyselVadeDialog = true;
      }
    },
    // Tevkifat secenegi: her isaretlenisinde uyari + onay istenir. Onaylanmazsa
    // secenek geri alinir (tevkifatUyariIptal).
    "faturaList.Opsiyonlar.TevkifatiFaturaTutarinaGoreHesapla": function(val) {
      if (val === true) {
        this.tevkifatUyariOnay = false;
        this.tevkifatUyariDialog = true;
      }
    },
    "faturaList.FaturaTarih":function(val)
    {
if (this.faturaList.Opsiyonlar.DovizliFatura==true && this.faturaList.DovizBilgi.DDovizTipi!=null)
{
  this.kurgetir(this.faturaList.DovizBilgi.DDovizTipi);
}
    },
    "faturaList.Filtreler.BaslangicCariKod": function(val) {
      
      if(this.selected.length != 0 || this.itemsTicket.length != 0){
          this.selected = [];
          this.itemsTicket = [];
      }
      
      this.faturaList.Filtreler.BitisCariKod = val;
      this.$refs.bitisCariAyarla.carigetir(
        this.faturaList.Filtreler.BaslangicCariKod
      );
    },
    selected(val3) {
      if (val3.length > 0) {
        this.seciliBiletbtn = false;
      } else {
        this.seciliBiletbtn = true;
      }
    },
    "faturaList.Filtreler.HatBilgi": function() {
      this.dizayngetir();
    },

    "faturaList.Opsiyonlar.DovizliFatura": function(val) {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      if (val == true) {
        this.dovizlifaturami = true;

        var params1 = {
          CompanyCode: credentials.SirketKodu,
        };

        this.$http
          .post(auth.API_URL + "api/currency/List", params1, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          })
          .then(
            (response) => {
              this.doviztipi = response.body;
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-Döviz";
                this.snackbar = true;
              } else {
                this.text1 = "Service Unavailable-Döviz";
                this.snackbar = true;
              }
            }
          );
      } else {
        this.dovizlifaturami = false;
        this.faturaList.DovizBilgi.DDovizTipi = null;
        this.faturaList.DovizBilgi.DKur = 0;
      }

 
      var params = {
        SirketKodu: credentials.SirketKodu,
        FaturaTip: "O",
        HatTipi: this.faturaList.Filtreler.HatBilgi,
        TumFiltre: true,
        DovizliFatura: val,
      };

      this.$http
        .post(auth.API_URL + "api/TicketInvoice/InvoiceMainTableList", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.dizaynsec = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-InvoiceXsltTableList";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-InvoiceXsltTableList";
              this.snackbar = true;
            }
          }
        );
    },
  },
  computed: {
    /**
     * Secili biletlerin Net Tutar toplami.
     *
     * Tabloda her satirin "Net Tutar" sutununda gosterdigi alanin ayni.
     * itemsTicket satirlari degeri API'den geldigi gibi tasiyor
     * (FaturaBilet.NetTutar -> Double), bu yuzden burada bicim cozmeye gerek
     * yok. Yine de tutarasayi'dan geciriliyor: kardes sayfada (bilet/index)
     * tam bu alan liste kurulurken "1,234.56" metnine cevriliyor ve dogrudan
     * Number() cagirmak toplami sessizce 0 yapiyordu.
     *
     * NOT: cariler farkli oldugunda selected, itemsTicket yerine ham
     * response.body ile dolduruluyor (asagida ~1845). Iki sekilde de NetTutar
     * ust seviyede duruyor, toplama etkilenmiyor.
     */
    secilentoplamtutar() {
      var toplam = 0;

      for (var i = 0; i < this.selected.length; i++) {
        var kayit = this.selected[i];
        if (!kayit) { continue; }

        var deger = this.tutarasayi(kayit.NetTutar);
        if (!isNaN(deger)) { toplam = toplam + deger; }
      }

      return toplam;
    },
  },
  filters: {
    moneyformat: function(m) {
      return helpers.moneyformat(m);
    },
  },
  methods: {
    getparabirimi() {
      return helpers.getparabirimi();
    },
    /**
     * Tutari sayiya cevirir. Sayi ise oldugu gibi doner; "1,234.56" gibi
     * binlik ayracli metinde ayraclari atar; cevrilemezse NaN doner ve
     * cagiran satiri atlar.
     */
    tutarasayi(deger) {
      if (typeof deger === "number") { return deger; }
      if (deger === null || deger === undefined) { return NaN; }

      return Number(String(deger).replace(/,/g, ""));
    },
    durdurGonderim() {
    this.stopRequested = true;
  },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    async gonder2(chunk)   {
     
  if (!this.load1){
      var params = {
    ticketList: chunk,
    invoiceInput: this.yedekClass,
  };

  params.invoiceInput.Filtreler.UnvanDegistir = this.changeTitleInfo;
try
{
 const response = await this.$http.post(
      auth.API_URL + "api/TicketInvoice/InvoiceSerialSave",
      params,
      {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
        },
      }
    );

    if (response.body.length > 0) {
      response.body.forEach(item => {
        this.faturaItems.push(item);
      });
    }
}
catch (error) {
      // Eskiden burada YALNIZCA console.error vardi: 500 donen her chunk sessizce
      // yutuluyor, kullaniciya ise asagida kosulsuz "Islem tamamlandi." yaziliyordu.
      // FaturaID=0 hatasinin uretimde fark edilmeden yasamasinin sebebi buydu.
      // CLAUDE.md: hata dalinda sunucunun GERCEK mesaji gosterilmeli.
      this.gonderimHatasi = true;
      this.text1 = (error && error.status !== undefined)
        ? tool.HataMesajiCoz(error, this.$t.bind(this))
        : ((error && error.message) || String(error));
      this.snackbar = true;
}
 

  
   
    }
    },

    async gonder1(chunks2) {
      this.totalChunks = chunks2.length;
  this.currentChunk = 0;
  this.stopRequested = false;
      for (const chunk of chunks2) {
        if (this.stopRequested) {
      this.kayitvarmesaj = "Gönderim kullanıcı tarafından durduruldu.";
      this.loadingvmodelProgress = false;
      console.log(this.faturaItems);
      return;
    }
        await this.gonder2(chunk);
        this.currentChunk++;
        this.progressPercent = Math.floor((this.currentChunk / this.totalChunks) * 100);
        await this.delay(1000);
      }
     
    },

    faturalav3() {
      const chunks2 = this.chunkArray();

      // GONDERILECEK NESNE BURADA SABITLENIR.
      //
      // yedekClass eskiden SADECE getList() icinde "this.yedekClass = this.faturaList"
      // ile aliniyordu ve bu bir kopya degil ALIAS'ti. faturaList ise opsiyoniptal() ve
      // filtreiptal() icinde derin kopyaya YENIDEN BAGLANIYOR; o andan sonra ekranda
      // dogrulanan nesne (faturaList) ile POST edilen nesne (yedekClass) ayrisiyordu.
      // Bayat nesnenin FaturaID'si dizayngetir() tarafindan null'lanmis oluyor ve
      // sunucuya FaturaID=0 gidiyordu (FaturaID C# tarafinda non-nullable int; JSON'daki
      // null 0'a duser ve IViewFaturaSeriSave'deki guard patlar).
      //
      // Burada TEK bir derin kopya aliniyor: hem faturalasor()'un dogruladigi nesneyle
      // ayni, hem de tum chunk'lar boyunca degismez. Canli referans (this.faturaList)
      // vermek yetmezdi: gonder2 govdeyi her chunk'ta yeniden kuruyor ve gonderim
      // ortasinda faturaList yeniden baglanirsa chunk'lar farkli nesneler yollardi.
      this.yedekClass = JSON.parse(JSON.stringify(this.faturaList));

      // Savunma: dogrulama ile gonderim arasinda bir daha ayrisma olursa istek hic
      // gitmesin. Sunucuya bozuk govde yollayip 500 almaktansa kullaniciya soyleyelim.
      if (!this.yedekClass.FaturaBilgi || !this.yedekClass.FaturaBilgi.FaturaID) {
        this.text1 = this.$t('Please-choose-invoice-design');
        this.snackbar = true;
        return Promise.resolve();
      }

      this.gonderimHatasi = false;
  this.loadingvmodelProgress = true;
  this.dialogopsiyon = false;
  this.faturadialog = false;
  this.carilerayni = false;
  this.load1 = false;
  this.secilibutonshow = false;

      // Eskiden burasi setTimeout(async () => {...}, 1000) idi ve HICBIR SEY
      // DONDURMUYORDU. Onay butonu artik kaydetbutonu: butonu ancak bu Promise
      // cozulene kadar pasif tutabiliyor, dolayisiyla gonderimin TAMAMINI kapsayan
      // bir Promise dondurulmek zorunda. Gecikme de ayni sekilde korunuyor.
      return this.delay(1000)
        .then(() => this.gonder1(chunks2))
        .catch((hata) => {
          // gonder2 kendi hatalarini yakaliyor; buraya ancak beklenmedik bir istisna
          // duser. Yine de ele aliniyor, yoksa asagidaki bayraklar acik kalir ve
          // ekranda spinner sonsuza kadar doner.
          this.gonderimHatasi = true;
          this.text1 = (hata && hata.message) || String(hata);
          this.snackbar = true;
        })
        .then(() => {
          this.faturaSonView = true;
          // Eskiden chunk'larin hepsi 500 donse bile kosulsuz "Islem tamamlandi."
          // yaziliyordu; kullanici basarisiz islemi basarili saniyordu.
          this.kayitvarmesaj = this.gonderimHatasi
            ? "İşlem hatalarla tamamlandı, lütfen sonuç listesini kontrol edin."
            : "İşlem tamamlandı.";
          this.load1=true;
          this.loadingvmodelProgress = false;
        });
    },

    filtrelecontrol()
    {
    if (this.faturaList.Filtreler.BaslangicCariKod==this.faturaList.Filtreler.BitisCariKod && this.warningNote!='')
    {
           this.warningNotedialog=true;
    }
    else
    {
      this.$refs.entegratorsecim.control();
    }
      
    },
     warningOk()
    {
       this.warningNotedialog=false;
       this.$refs.entegratorsecim.control();
      
    },
     warningCancel()
    {
     this.warningNotedialog=false;
      
    },
    /**
     * Satirdaki biletin bilet sayfasi adresi.
     *
     * Bicim bilet/index.vue'daki gitliste() ile AYNI; fark, orada window.open
     * cagrilmasi, burada gercek bir <a href> verilmesi. Boylece orta tik ve
     * "baglantiyi yeni sekmede ac" da calisiyor, acilir pencere engelleyicisine
     * takilmiyor.
     *
     * isl=get: bu ekran yalnizca faturalanmamis SATIS biletlerini listeliyor,
     * iptal (void) bilet bu listeye girmiyor; o yuzden voidget dalina gerek yok.
     *
     * ucustipi yalnizca DOLUYSA ekleniyor: liste ucunun bu alani dondurmesi
     * yeni (FaturaSeriBiletList), eski bir API'ye karsi calisirken bos bir
     * parametre gondermek yerine hic gondermemek daha dogru. Bilet yuklemesi
     * zaten bilet no + havayolu + sirket ile yapiliyor, ucus tipini WHERE'de
     * kullanmiyor (BiletLoad).
     */
    biletSayfasiAdresi(bilet) {
      if (!bilet) return "#";

      var adres =
        "#/bilet/yeni/id?isl=get" +
        "&hyolukod=" + encodeURIComponent(bilet.HavaYoluKodu || "") +
        "&biletno=" + encodeURIComponent(bilet.BiletNo || "");

      if (bilet.UcusTip) {
        adres += "&ucustipi=" + encodeURIComponent(bilet.UcusTip);
      }

      return adres;
    },
    /**
     * Tevkifat esigini sirket parametrelerinden okur ve secenegin altinda
     * gosterir. Esik artik kodda sabit degil (SirketParam.
     * BiletTevkifatFaturaTutari), bu yuzden ekranda da sabit yazilamaz --
     * kullanici hangi tutarin gecerli oldugunu gormeli.
     *
     * Opsiyon dialogu her acildiginda cagriliyor: deger seyrek degisiyor ama
     * bayat gostermektense taze okumak yegleniyor, istek kucuk.
     */
    tevkifatEsiginiGetir() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      var params = { SirketKodu: credentials.SirketKodu };

      return this.$http
        .post(auth.API_URL + "api/Parameters/CompanyGet", params, {
          headers: { Authorization: "Bearer " + auth.getAuthHeader() },
        })
        .then(
          (response) => {
            var deger = response.body ? response.body.BiletTevkifatFaturaTutari : null;
            // Sunucu kolon yoksa/bossa 0 dondurebiliyor; o durumda satiri hic
            // gostermiyoruz, yanlis bir esik yazmaktansa hic yazmamak dogru.
            this.tevkifatEsigi = deger > 0 ? deger : null;
          },
          (response) => {
            this.tevkifatEsigi = null;
            this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this));
            this.snackbar = true;
          }
        );
    },
    tevkifatUyariOnayla() {
      this.tevkifatUyariDialog = false;
    },
    tevkifatUyariIptal() {
      this.tevkifatUyariDialog = false;
      // onaylanmadi: secenek isaretli kalmasin
      this.faturaList.Opsiyonlar.TevkifatiFaturaTutarinaGoreHesapla = false;
    },
    deneyselVadeOnayla() {
      this.deneyselVadeDialog = false;
    },
    deneyselVadeIptal() {
      this.deneyselVadeDialog = false;
      // onaylanmadi: secenek isaretli kalmasin
      this.faturaList.Opsiyonlar.BiletOdemeVadesiFaturaTarihindenHesapla = false;
    },
    EntegratorAyarlariKayitEdildi() {
     
     this.$refs.entegratorsecim.close();

     this.filtrele();
   },
   EntegratorVar()
   {
    this.filtrele();
   },
 
   EntegratorAyarlariKayitEdilmedi() {
     alert("Entegrator Ayarları Kayıt Edilmedi");
     this.$refs.entegratorsecim.close();
   },
    getCurrentData(val){

     this.faturaList.EFaturaBilgi.Unvani = val.Title;
     this.faturaList.EFaturaBilgi.Unvani2 = val.Title2;
     this.faturaList.EFaturaBilgi.Adres1 = val.Invoice.Address;
     this.faturaList.EFaturaBilgi.Adres2 = val.Invoice.DeliveryAddress;
     this.faturaList.EFaturaBilgi.IlceSehir = val.Invoice.Province;
     this.faturaList.EFaturaBilgi.VergiDairesi = val.Invoice.TaxOffice;
     this.faturaList.EFaturaBilgi.VergiNo = val.Invoice.TaxNumber;
     this.faturaList.EFaturaBilgi.TcKimlikNo = val.Invoice.IdentityNumber;
     this.faturaList.EFaturaBilgi.Email = val.Email;
     this.faturaList.EFaturaBilgi.Adi = val.Invoice.PerFirstName;
     this.faturaList.EFaturaBilgi.Soyadi = val.Invoice.PerFamilyName;
     this.faturaList.EFaturaBilgi.TUnvani = val.Invoice.PerTitle;
     this.faturaList.EFaturaBilgi.DigerAdi = val.Invoice.PerMiddleName;
     this.faturaList.EFaturaBilgi.OnAdiEki = val.Invoice.PerNameSuffix;
     this.currentSearchControl = false; // cari yuklemede sistem kitlenirse faturalama yapilmamasi icin kontrol ediliyor
     this.warningNote=val.WarningNote;
     try{
      this.warningNote=this.warningNote.replace(/[\n\r\t]/gm, "");

     }catch{}
     
    },
    customSort(items, index, isDesc) {
      items.sort();

      return items;
    },
    faturayazdir(faturainfo) {
      this.faturaList.FaturaBilgi.FaturaPdfID = faturainfo.PdfID;
      var prm = {
        id: faturainfo.EFaturaID,
        guid: faturainfo.FaturaGuid,
      };

      this.$refs.reportbrosablon.Print(prm).then((confirm) => {
        if (confirm.sonuc != true) {
          this.text1 = confirm.mesaj;
          this.snackbar = true;
        }
      });
    },
    xsltsec(Faturaid) {
      this.dizaynsec.forEach((element) => {
        if (element.FaturaId == Faturaid) {
          this.faturaList.FaturaBilgi.FaturaXSLTID = element.FaturaXsltId;
          this.faturaList.FaturaBilgi.FaturaPdfID = element.FaturaPdfID;
        }
      });
    },

    kurgetir(kod) {
      // Bos doviz kodunda kur sorulmaz; sunucu "Doviz Kodu Bos olamaz" diye 500 donuyordu.
      if (kod == null || kod == '') {
        return;
      }

      var params1 = {
        Tarih: this.faturaList.FaturaTarih,
        DovizKod: kod,
      };

      this.$http
        .post(auth.API_URL + "api/Definitions/GetWebRate", params1, {
          headers: auth.getAuthCompaniesInfo()
        })
        .then(
          (response) => {
          if(response.body == 0.0){
           this.faturaList.DovizBilgi.DKur = 1
          }else{
          this.faturaList.DovizBilgi.DKur = response.body
          }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Kur Hesapla";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Kur Hesapla";
              this.snackbar = true;
            }
          }
        );
    },
    mesajiptal() {
      this.faturadialog = false;
    },
    opsiyoniptal() {
      this.dialogopsiyon = false;
      this.faturaList = this.cancelValue;
    },
    faturalasor() {
      if (this.faturaList.GibSeri != null || this.faturaList.GibSeri != '') {
        if (
          this.faturaList.FaturaBilgi.FaturaID != null &&
          this.faturaList.FaturaBilgi.FaturaID != "" &&
          this.faturaList.FaturaBilgi.FaturaID != 0
        ) {
          this.xsltsec(this.faturaList.FaturaBilgi.FaturaID);

          this.faturadialog = true;
          this.dialogmesajı = this.$t('you-sure-that-want-invoice-your-tickets-your-selections');
        } else {
          this.text1 = this.$t('Please-choose-invoice-design');
          this.snackbar = true;
        }
      } else {
        this.text1 = this.$t('Please-select-GIB-series');
        this.snackbar = true;
      }
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.itemsTicket.slice();
    },
    dizayngetir() {
      this.loadingvmodel = true;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      this.dizaynsec.length = 0
      this.faturaList.FaturaBilgi.FaturaID = null
      var params = {
        SirketKodu: credentials.SirketKodu,
        FaturaTip: "O",
        HatTipi: this.faturaList.Filtreler.HatBilgi,
        TumFiltre: true,
        DovizliFatura: false,
      };

      this.$http
        .post(auth.API_URL + "api/TicketInvoice/InvoiceMainTableList", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.dizaynsec = response.body;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.loadingvmodel = false;
              this.text1 = "Service Unavailable-InvoiceXsltTableList";
              this.snackbar = true;
            } else {
              this.loadingvmodel = false;
              this.text1 = "Service Unavailable-InvoiceXsltTableList";
              this.snackbar = true;
            }
          }
        );
    },
    getList: getList,
    filtrele: filtrele,
    filtreiptal: filtreiptal,
    faturala: faturala,
    efaturagoster: efaturagoster,
    opsiyonlarial: opsiyonlarial,
    chunkArray:chunkArray
  },
};

function opsiyonlarial() {
  this.cancelValue = JSON.parse(JSON.stringify(this.faturaList));

  this.faturaList.FaturaTarih = getDateNow();

  this.dizayngetir();

  // Tevkifat secenegi altinda gosterilen esik tutari.
  this.tevkifatEsiginiGetir();

  var credentials = JSON.parse(window.localStorage.getItem("credentials"));
  this.faturaList.GibSeri = null
  if (this.faturaList.Filtreler.EFaturaKayitli == false) {
    var paramsEarchive = {
      CompanyCode: credentials.SirketKodu,
      PassiveControl: true,
    };
    this.$http.post(auth.API_URL + "api/Definitions/GibSerialEarchiveList", paramsEarchive, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
        },
      })
      .then(
        (response) => {
          if(response.body.length == 1){
              this.faturaList.GibSeri = response.body[0].Seri 
          }
              this.gibSeri1 = response.body;

        },
        (response) => {
          if (response.status === 0) {
            this.text1 = "Service Unavailable";
            this.snackbar = true;
          } else {
            this.text1 = "Service Unavailable";
            this.snackbar = true;
          }
        }
      );
  } else {
    var paramsEBiil = {
      CompanyCode: credentials.SirketKodu,
      PassiveControl: true,
    };

    this.$http.post(auth.API_URL + "api/Definitions/GibSerialList", paramsEBiil, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
        },
      })
      .then(
        (response) => {
          if(response.body.length == 1){
              this.faturaList.GibSeri = response.body[0].Seri 
          }
           this.gibSeri1 = response.body;
        },
        (response) => {
          if (response.status === 0) {
            this.text1 = "Service Unavailable";
            this.snackbar = true;
          } else {
            this.text1 = "Service Unavailable";
            this.snackbar = true;
          }
        }
      );
  }

      if(this.faturaList.Filtreler.BaslangicCariKod == this.faturaList.Filtreler.BitisCariKod && this.faturaList.Filtreler.BaslangicCariKod != null){
        this.isCurrentSame = true;
      }else{
        this.isCurrentSame = false;
        this.changeTitleInfo = false;
      }
  this.dialogopsiyon = true;
}

function filtrele() {

  if(this.faturaList.Filtreler.BaslangicCariKod == undefined ||
    this.faturaList.Filtreler.BitisCariKod == undefined ||
    this.faturaList.Filtreler.BaslangicCariKod == null ||
    this.faturaList.Filtreler.BitisCariKod == null 
    ){
      this.faturaList.EFaturaBilgi.Unvani = null;
      this.faturaList.EFaturaBilgi.Unvani2 = null;
      this.faturaList.EFaturaBilgi.Adres1 = null;
      this.faturaList.EFaturaBilgi.Adres2 = null;
      this.faturaList.EFaturaBilgi.IlceSehir = null;
      this.faturaList.EFaturaBilgi.VergiDairesi = null;
      this.faturaList.EFaturaBilgi.VergiNo = null;
      this.faturaList.EFaturaBilgi.TcKimlikNo = null;
      this.faturaList.EFaturaBilgi.Adi = null;
      this.faturaList.EFaturaBilgi.Soyadi = null;
      this.faturaList.EFaturaBilgi.TUnvani = null;
      this.faturaList.EFaturaBilgi.DigerAdi = null;
      this.faturaList.EFaturaBilgi.OnAdiEki = null;
      this.faturaList.EFaturaBilgi.Email = null;
      this.isCurrentSame = false;
      this.changeTitleInfo = false;
    }
  
  this.anaCancelValue = JSON.parse(JSON.stringify(this.faturaList));

  var credentials = JSON.parse(window.localStorage.getItem("credentials"));

  var params1 = {
    CompanyCode: credentials.SirketKodu,
  };

  this.$http
    .post(auth.API_URL + "api/TicketDefinitons/AirlineList", params1, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
      },
    })
    .then(
      (response) => {
        this.itemsairlinelist = response.body;
      },
      (response) => {
        if (response.status === 0) {
          this.text1 = "Service Unavailable";

          this.snackbar = true;
        } else {
          this.text1 = "Service Unavailable";

          this.snackbar = true;
        }
      }
    );

  this.$http
    .post(auth.API_URL + "api/TicketHelpers/GetCrsList", params1, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
      },
    })
    .then(
      (response) => {
        var i = 0;
        response.body.forEach((element) => {
          var yeni = {
            text: element,
            value: i,
          };
          this.gdsitems.push(yeni);
          i = i + 1;
        });
      },
      (response) => {
        if (response.status === 0) {
          this.text1 = "Service Unavailable";

          this.snackbar = true;
        } else {
          this.text1 = "Service Unavailable";

          this.snackbar = true;
        }
      }
    );

  this.dialogfiltre = true;

  this.$http
    .post(auth.API_URL + "api/Definitions/CurrentGroupList", params1, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
      },
    })
    .then(
      (response) => {
        this.hesapgurubu = response.body;
      },
      (response) => {
        if (response.status === 0) {
          this.text1 = "Service Unavailable";
          this.snackbar = true;
        } else {
          this.text1 = "Service Unavailable";
          this.snackbar = true;
        }
      }
    );
}

function filtreiptal() {
  this.faturaList = this.anaCancelValue;
  this.dialogfiltre = false

  this.faturaList.FaturaTarih = getDateNow();

}

function getList() {
  
  this.kayitvarmi = false;
  var credentials = JSON.parse(window.localStorage.getItem("credentials"));
  this.dialogfiltre = false;
  this.yedekClass = this.faturaList;
  this.faturadialog = false;
  var tmpTicketList =[];
  this.itemsTicket = [];
  this.faturaItems = [];
  this.faturaSonView = false;
  this.selected = [];
  this.faturaList.SirketKodu = credentials.SirketKodu;
  this.faturaList.FaturaTarih = null;
  var params = this.faturaList;
  this.load1 = false;
  this.$http
    .post(auth.API_URL + "api/TicketInvoice/InvoiceSerialTicketList", params, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
      },
    })
    .then(
      (response) => {
        if (response.body.length > 0) {
          tmpTicketList = response.body;

          tmpTicketList.forEach((value, index) => {
            this.itemsTicket.push({
              SirketKodu: value.SirketKodu,
        BiletNo: value.BiletNo,
        FormNo: value.FormNo,
        HavaYoluKodu: value.HavaYoluKodu,
        UcusTip: value.UcusTip,
        OdemeTarihi: value.OdemeTarihi,
        CariKod: value.CariKod,
        OnlyCariKod: value.OnlyCariKod,
        NetTutar: value.NetTutar,
        KdvTutar: value.KdvTutar,
        ServisTutar: value.ServisTutar,
        YolcuAdi: value.YolcuAdi,
        Parkurlar: value.Parkurlar,
        RezervasyonVeren: value.RezervasyonVeren,
        RezervasyonAlan: value.RezervasyonAlan,
        BiletKod:value.HavaYoluKodu + value.BiletNo
      });
});

          
          this.secilibutonshow = true;
          if (
            this.faturaList.Filtreler.BaslangicCariKod != null &&
            this.faturaList.Filtreler.BitisCariKod != null &&
            this.faturaList.Filtreler.BaslangicCariKod ==
              this.faturaList.Filtreler.BitisCariKod
          ) {
            this.carilerayni = true;
            this.load1 = true;
            this.kayitvarmi = true;
            this.kayitvarmesaj =
              this.$t('Invoice-has-yet-be-completed') +
               this.$t('records found. Please tickets to be invoiced',{value: response.body.length}) ;
          } else {
            this.carilerayni = false;
            this.selected = response.body;
            this.load1 = true;
            this.kayitvarmi = true;
            this.kayitvarmesaj =
             this.$t('Invoice-has-yet-be-completed') +
              response.body.length +
              " " + this.$t('Number-of-Records-Found');
          }
        } else {
          this.kayitvarmi = false;
          this.kayitvarmesaj = "";
          this.text1 = this.$t('No-records-found-invoiced');
          this.dialogfiltre = false;
          this.snackbar = true;
          this.load1 = true;
          this.secilibutonshow = false;
        }
      },
      (response) => {
        if (response.status === 0) {
          this.text1 = "Service Unavailable-InvoiceSerialTicketList";
          this.snackbar = true;
          this.load1 = true;
        } else {
          this.text1 = "Service Unavailable-InvoiceSerialTicketList";
          this.snackbar = true;
          this.load1 = true;
        }
      }
    );
}
function chunkArray() {
      const result = [];
      for (let i = 0; i < this.selected.length; i += this.paketSayi) {
        result.push(this.selected.slice(i, i + this.paketSayi));
      }
      return result;
    }
function faturala() {
  // Promise DONDURULUR: onay butonu (kaydetbutonu) kilidini bu Promise'in
  // cozulmesine gore aciyor. Dondurulmezse buton aninda tekrar aktif olur ve
  // ikinci tik ikinci bir gonderim dongusu baslatir (mukerrer fatura riski).
  return this.faturalav3();
}

function efaturagoster(v) {
  var params = {
    id: v.EFaturaID,
    guid: v.FaturaGuid,
  };

  var credentials = JSON.parse(window.localStorage.getItem("credentials"));
  this.$http
    .post(auth.API_URL + "api/EFatura/FaturaShow", params, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
        CariSirketNo: credentials.SirketKodu.toString(),
        CoperSirketNo: credentials.CoperSirketNo.toString(),
      },
    })
    .then(
      (response) => {
        this.faturadialoggoster = true;
        document.getElementById("demo2").innerHTML = response.body;
      },
      (response) => {
        if (response.status === 0) {
          this.text1 = "Service Unavailable-Fatura Show";
          this.snackbar = true;
        } else {
          this.text1 = "Service Unavailable-Fatura Show";
          this.snackbar = true;
        }
      }
    );
}

function getDateNow() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }
  today = yyyy + "-" + mm + "-" + dd;
  return today;
}
</script>

<style scoped>
/* Vuetify 1.3.5'te .v-label "white-space: nowrap"; bu etiketler 400px'lik opsiyon
   dialogunu tasiriyordu. Turkce 354px, Almanca/Fransizca cevirileri daha da uzun. */
.vade-secenegi >>> .v-label,
.tevkifat-secenegi >>> .v-label {
  white-space: normal;
  line-height: 1.3;
}

/* Bilet numarasi hucresi bir baglanti; satira tiklayinca satir SECILIYOR, bu
   yuzden baglantinin tiklanabilir oldugu gorunmeli (alti cizili + imlec). */
.bilet-baglantisi {
  text-decoration: underline;
  cursor: pointer;
}

/* Checkbox ve info butonu yan yana. v-checkbox blok eleman oldugu icin flex
   sarmalayici gerekiyor.

   Hizalama "center": once flex-start + margin-top denendi ve ikon etiketin
   USTUNDE kaldi (E2E ekran goruntusunde olculdu). center, tek satirlik etikette
   ikonu satirin uzerine oturtuyor; etiket sardiginda da iki satirin ortasinda
   kaliyor ki kabul edilebilir. */
.tevkifat-satiri {
  display: flex;
  align-items: center;
}

.tevkifat-info {
  cursor: pointer;
  margin-left: 4px;
}

/* Aciklama varsayilan olarak GIZLI, info butonuyla aciliyor. Sol bosluk
   checkbox kutusunun genisligi kadar, boylece etiketle hizali duruyor. */
.tevkifat-aciklama {
  margin: 4px 0 8px 32px;
  line-height: 1.3;
}
</style>
